import { init, priceDecorator, thumbnailDecorator } from "@nosto/preact";
import { Serp, Category, Autocomplete, History } from "./components";
import { defaultConfig } from "./config";

import "./styles/index.css";
import { getWizardConfig } from "./wizard";

init({
  ...window.nostoTemplatesConfig,
  serpComponent: Serp,
  historyComponent: History,
  autocompleteComponent: Autocomplete,
  categoryComponent: Category,
  inputCssSelector: ".main-search__input",
  contentCssSelector: "#content",
  //dropdownCssSelector: "div[data-section-type='header']",
  dropdownCssSelector: ".main-search__container.container",
  formCssSelector: ".main-search__form",
  hitDecorators: [priceDecorator(), thumbnailDecorator({ size: "9" })],
  serpUrlMapping: {
    query: "q",
    "products.filter": "filter",
    "products.page": "page",
    "products.size": "pageSize",
    "products.sort": "sort"
  },
  // Uncomment to redirect to search page instead of rendering on the same page
  serpPath: "/pages/search-results-page",

  // Uncomment to redirect to search page instead of rewriting browser history
  // serpPathRedirect: true,
  serpQuery: {
    products: {
      fields: [
        "productId",
        "url",
        "name",
        "imageUrl",
        "imageHash",
        "thumbUrl",
        "description",
        "brand",
        "availability",
        "price",
        "priceText",
        "listPrice",
        "priceCurrencyCode",
        "ratingValue",
        "reviewCount",
        // 'customFields.key', 'customFields.value',
        "skus.id",
        "skus.name",
        "skus.price",
        "skus.listPrice",
        "skus.priceText",
        "skus.url",
        "skus.imageUrl",
        //"skus.inventoryLevel",
        //"skus.customFields.key",
        //"skus.customFields.value",
        "skus.availability",
      ],
      facets: ["*"],
      size: defaultConfig.serpSize,
      from: 0
    }
  },
  autocompleteQuery: {
    products: {
      fields: [
        "productId",
        "url",
        "name",
        "description",
        "imageUrl",
        "thumbUrl",
        "brand",
        "availability",
        "price",
        "priceText",
        "listPrice",
        "priceCurrencyCode",
        "ratingValue",
        "reviewCount",
        "skus.imageUrl",
        "skus.price",
        "skus.listPrice",
        "skus.id",
      ],
      size: defaultConfig.autocompleteProductsSize
    },
    keywords: {
      fields: ["keyword", "_highlight.keyword"],
      size: defaultConfig.autocompleteKeywordsSize,
      facets: ["*"]
    }
  },
  compressUrlParameters: true,
  fallback: true,
  // // Uncomment for Category Merchandising
  categoryCssSelector: ".shopify-section div[data-section-type='collection-template']",
  categoryQuery() {
    return {
      name: "serp",
      products: {
        categoryId: this.categoryId(),
        categoryPath: this.categoryPath(),
        size: defaultConfig.serpSize,
        from: 0
      }
    };
  },
  // Apply configuration wizard last
  ...getWizardConfig()
  // Configuration here will override the changes in the wizard
});